module.exports = __webpack_public_path__ + "img/nedborfelt.464fee49.jpg";